import Header from 'layouts/Header';
import Loading from 'layouts/Loading/loading';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import UserAPI from 'services/apis/UserAPI';
import StocksAPI from 'services/apis/StocksAPI';
import UserActions from 'store/stores/User/actions';
import Tab from 'uikit/Tab';
import { TABS } from './constants';
import Modules from './modules';
import Styled from './styles';

const Dashboard = () => {
  const { t } = useTranslation('dashboardStock');
  const dispatch = useDispatch();
  const [tab, setTab] = useState('');
  const [stats, setStats] = useState({});
  const userData = useSelector(state => state.User.user);
  const localUserAPI = new UserAPI();
  const localStocksAPI = new StocksAPI();

  useEffect(() => {
    let _mounted = true;
    if (_mounted) {
      onGetUserData();
      onGetStats();
    }
    setTimeout(() => {
      if (_mounted) setTab(t(TABS[0].name));
    }, 1000);

    return () => {
      _mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }, [tab]);

  const onHandleTab = _tab => {
    setTab(_tab);
  };

  const onDisplayTab = _tab => {
    const _key = TABS.find(_step => t(_step.name) === _tab)?.id;
    const _tabs = {
      1: <Modules.Tab1 stats={stats} />,
      2: <Modules.Tab2 stats={stats} />,
      3: <Modules.Tab3 stats={stats} />,
      4: <Modules.Tab4 stats={stats} />
    };
    return _tabs[_key];
  };

  const onGetUserData = () => {
    localUserAPI.fetchProfile().then(response => {
      if (response && response.id) {
        dispatch(UserActions.PatchUserData(response));
      }
    });
  };

  const onGetStats = () => {
    localStocksAPI.fetchStats().then(response => {
      if (response) {
        setStats(response);
      }
    });
  };

  return (
    <Styled.Container>
      <Header
        title={{ color: t('title.color') }}
        subtitle={t('subtitle')}
        star={true}
      />
      {tab.length === 0 ? (
        <Loading />
      ) : (
        <>
          <Tab init={tab} border={false} big={false} onSelect={onHandleTab}>
            {TABS.map((_tab, _index) => (
              <div key={`tab_item_${_index}`} label={t(_tab.name)} />
            ))}
          </Tab>

          {userData && onDisplayTab(tab)}
        </>
      )}
    </Styled.Container>
  );
};

export default Dashboard;
